import dynamic from "next/dynamic";
import Seo from "../common/Seo";
import Header3 from "../header/header-rslhome";
// import Header3 from "../../components/header/header-rslhome/index_b_new";
import Hero3 from "../hero/hero-rslhome";
import OurServices from "../OurServices";
import OurFleets from '../OurFleets';
import TopActivities from "../TopActivites";
import TrustedPartners from "../TrustedPartners";
import RslSuperAppBanner from '../RslSuperAppBanner'
import FooterNew from '../footer/footer-new';
import { useRouter } from "next/router";
import Box from '@mui/material/Box';
import Head from "next/head";
import React, { useRef } from "react";
import { bannerHeight } from "../../utils/bannerHeight";

const RslHome = ({ meta }) => {
  const router = useRouter();
  const heroRef = useRef(null);
  const [hourly, setHourly] = React.useState(false);

  // function to scroll
  const scrollToHero = (title) => {
    if (title === "Hourly") {
      setHourly(true);
    } else {
      setHourly(false);
    }


    if (heroRef.current) {
      heroRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    <>
      <Seo meta={meta} />

      <div style={{ height: bannerHeight() }}>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
          />
        </Head>
        {/* <Seo pageTitle="Royalsmartlimousine - Lifestyle" /> */}

        <Header3 />

        {/* attach ref here */}
        <div ref={heroRef} style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: bannerHeight(),
          zIndex: 1,
        }}
        >
          <Hero3 hourly={hourly} />
        </div>
      </div>

      <Box
        component="section"
        className="mobile-travelcard"
        sx={{
          position: "relative",
          zIndex: 2,
          pt: `${bannerHeight()}px`, // pushes content below fixed hero
          background: "#fff",
          backgroundImage: "url('/img/banner/grid.svg')",
        }}
      >
        <div className="container-lg travel-card__container rsl__Wrapper">
          <OurServices scrollToHero={scrollToHero} />
        </div>
        <OurFleets />
        <TopActivities />
        <TrustedPartners />

        <Box sx={{ py: 4, px: { xs: 2, md: 8, lg: 4, xl: 2 } }}>
          <RslSuperAppBanner />
        </Box>

        <FooterNew bgcolor="#f8f8f8" />
      </Box>
    </>
  );
};

export default dynamic(() => Promise.resolve(RslHome), { ssr: false });
